export default __webpack_public_path__ + "static/media/education-graduate-glyph-16px.322a6437.svg";